import { Directive } from '@angular/core';
import { ElementRef, HostListener, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
	selector: '[viewerResizer]'
})
export class ViewerResizerDirective implements OnInit, OnDestroy {
	@Input() resizerLeft!: string;
	@Input() resizerRight!: string;
	@Input() resizerMin!: number;
	@Input() resizerMax!: number;
	@Input() resizerWidthWrapper!: string;

	private mouseMoveListener = this.onMouseMove.bind(this);
	private mouseUpListener = this.onMouseUp.bind(this);
	private mutationObserver: MutationObserver | null = null;

	constructor(
		private el: ElementRef,
		@Inject(DOCUMENT) private document: Document
	) { }

	ngOnInit() {
		this.document.defaultView?.addEventListener('resize', this.resetStyles);

		this.mutationObserver = new MutationObserver(() => {
			this.checkAndClearStyles();
		});

		this.mutationObserver.observe(this.el.nativeElement, {
			attributes: true,
			attributeFilter: ['class']
		});
	}

	ngOnDestroy() {
		this.document.defaultView?.removeEventListener('resize', this.resetStyles);
		this.removeMouseListeners();
		this.mutationObserver?.disconnect();
	}

	@HostListener('mousedown', ['$event'])
	onMouseDown(event: MouseEvent) {
		event.preventDefault();
		const overlay = this.document.querySelector('#resizer-overlay') as HTMLElement;
		if (overlay) overlay.classList.add('resizing');

		this.document.addEventListener('mousemove', this.mouseMoveListener);
		this.document.addEventListener('mouseup', this.mouseUpListener);
	}

	private onMouseMove(event: MouseEvent) {
		const x = event.pageX;
		const widthWrapper = this.document.querySelector(this.resizerWidthWrapper) as HTMLElement;
		const width = widthWrapper?.offsetWidth || 0;

		const min = this.resizerMin;
		const max = this.resizerMax;

		if (x > min && (x + max) < width) {
			const el = this.el.nativeElement as HTMLElement;
			const left = this.document.querySelector(this.resizerLeft) as HTMLElement;
			const right = this.document.querySelector(this.resizerRight) as HTMLElement;

			const rightPx = width - x;

			el.style.right = `${rightPx}px`;
			if (left) left.style.right = `${rightPx + 10}px`;
			if (right) right.style.left = `${x}px`;

			this.document.dispatchEvent(new CustomEvent('ngPintura.resize'));
		}
	}

	private onMouseUp() {
		const overlay = this.document.querySelector('#resizer-overlay') as HTMLElement;
		if (overlay) overlay.classList.remove('resizing');

		this.removeMouseListeners();
	}

	private removeMouseListeners() {
		this.document.removeEventListener('mousemove', this.mouseMoveListener);
		this.document.removeEventListener('mouseup', this.mouseUpListener);
	}

	private checkAndClearStyles() {
		const left = this.document.querySelector(this.resizerLeft) as HTMLElement;

		if (left?.classList.contains('panelOff')) {
			this.resetStyles();
		}
	}

	private resetStyles = () => {
		const el = this.el.nativeElement as HTMLElement;
		const left = this.document.querySelector(this.resizerLeft) as HTMLElement;
		const right = this.document.querySelector(this.resizerRight) as HTMLElement;

		if (left) left.removeAttribute('style');
		if (right) right.removeAttribute('style');
		el.removeAttribute('style');
	};
}
